var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnCircleOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM24 1.73494C36.2966 1.73494 46.2651 11.7033 46.2651 24C46.2651 36.2966 36.2966 46.2651 24 46.2651C11.7033 46.2651 1.73494 36.2966 1.73494 24C1.73494 11.7033 11.7033 1.73494 24 1.73494Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4875 16.702C18.1348 16.3493 17.5629 16.3493 17.2102 16.702L13.1215 20.79C12.9512 20.9543 12.8452 21.1848 12.8452 21.4401C12.8452 21.5315 12.8588 21.6198 12.8841 21.703C12.9258 21.8405 13.001 21.9701 13.1097 22.0788C13.2911 22.2601 13.5303 22.3482 13.7679 22.3431H34.2507C34.7495 22.3431 35.1539 21.9388 35.1539 21.4401C35.1539 20.9414 34.7495 20.5371 34.2507 20.5371H15.929L18.4875 17.9791C18.8402 17.6264 18.8402 17.0546 18.4875 16.702Z",
    fill: "#146EB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2507 25.6517H13.7484C13.2496 25.6517 12.8452 26.056 12.8452 26.5547C12.8452 27.0534 13.2496 27.4577 13.7484 27.4577H32.0716L29.5129 30.0159C29.1602 30.3686 29.1602 30.9404 29.5129 31.293C29.8657 31.6457 30.4375 31.6457 30.7902 31.293L34.8907 27.1932C35.2434 26.8406 35.2434 26.2688 34.8907 25.9162C34.7142 25.7397 34.4821 25.6515 34.2507 25.6517Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnCircleOutlineIcon);
export default __webpack_public_path__ + "static/media/return-circle-outline-icon.13eb9e3bb7d311a6b018b753c7b11ef4.svg";
export { ForwardRef as ReactComponent };